<template>
	<div>
		<!-- 取消按钮 -->
		<el-button class="cancel-btn" @click="close">{{ translate.ShowText('取消') }}</el-button>
	</div>
</template>

<script lang="ts" setup>
import translate from '@/api/translate';
const emits = defineEmits(["change"]);

const close = () => {
	emits("change");
};
</script>

<style lang="scss" scoped>
.cancel-btn {
	width: 100px;
	height: 40px;
	border-radius: 4px;
	font-size: 14px;
	line-height: 40px;
}
</style>